import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "residency-residents-filter-drawer__close-trigger" }
const _hoisted_2 = { class: "residency-residents-filter-drawer__fields-section" }
const _hoisted_3 = { class: "residency-residents-filter-drawer__fields-section" }
const _hoisted_4 = { class: "residency-residents-filter-drawer__footer-container" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { computed, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import {
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Select as ASelect,
} from 'ant-design-vue';

import {
  applyResidencyResidentsFilterDraft,
  draftsEqual,
  getResidencyResidentsScope,
  readResidencyResidentsFilterDraft,
  getSelectOptions,
  type ResidencyResidentsFilterDraft,
} from './sync-filters';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResidencyResidentsFilterDrawer',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "applied"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const applied = ref<ResidencyResidentsFilterDraft>({
  cluster: '',
  direction: '',
});

const draft = reactive<{
  cluster: string;
  direction: string;
}>({
  cluster: '',
  direction: '',
});

const viewportWidth = ref(window.innerWidth);

const drawerWidth = computed(() => (viewportWidth.value <= 576 ? '100%' : 800));

const hasDraftValues = computed(() =>
  Boolean(draft.cluster || draft.direction),
);

const hasChanges = computed(
  () =>
    draftsEqual(
      {
        cluster: draft.cluster,
        direction: draft.direction,
      },
      applied.value,
    ) === false,
);

const isResetDisabled = computed(() => !hasDraftValues.value);
const isApplyDisabled = computed(() => !hasChanges.value);

function syncDraftFromDom(): void {
  const current = readResidencyResidentsFilterDraft(getResidencyResidentsScope());

  draft.cluster = current.cluster;
  draft.direction = current.direction;
  applied.value = {
    cluster: current.cluster,
    direction: current.direction,
  };
}

function handleResize(): void {
  viewportWidth.value = window.innerWidth;
}

watch(
  () => props.open,
  (isOpen) => {
    if (!isOpen) return;
    syncDraftFromDom();
  },
);

function handleReset(): void {
  draft.cluster = '';
  draft.direction = '';
}

async function handleApply(): Promise<void> {
  const scope = getResidencyResidentsScope();
  const nextDraft: ResidencyResidentsFilterDraft = {
    cluster: draft.cluster,
    direction: draft.direction,
  };

  applyResidencyResidentsFilterDraft(scope, nextDraft);

  applied.value = nextDraft;
  emit('applied');
  emit('update:open', false);
}

onMounted(() => {
  syncDraftFromDom();
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ADrawer), {
    width: drawerWidth.value,
    open: __props.open,
    class: "residency-residents-filter-drawer",
    "body-style": { paddingBottom: '24px' },
    "footer-style": { textAlign: 'center', padding: '16px 48px 32px 48px' },
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:open', false)))
  }, {
    title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", { class: "residency-residents-filter-drawer__header-shell" }, [
        _createElementVNode("div", { class: "residency-residents-filter-drawer__header-overline" }, "Фильтр")
      ], -1)
    ]))]),
    closeIcon: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(CloseOutlined))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline btn-medium",
          disabled: isResetDisabled.value,
          onClick: handleReset
        }, " Сбросить ", 8, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-medium",
          disabled: isApplyDisabled.value,
          onClick: handleApply
        }, " Применить ", 8, _hoisted_6)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(AForm), {
        layout: "vertical",
        class: "residency-residents-filter-drawer__form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(AFormItem), {
              label: "Кластер",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASelect), {
                  value: draft.cluster,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((draft.cluster) = $event)),
                  options: _unref(getSelectOptions)('residencyResidentsCluster'),
                  placeholder: "Все кластеры"
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(AFormItem), {
              label: "Направление",
              class: "stc-ant-field-skin"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ASelect), {
                  value: draft.direction,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((draft.direction) = $event)),
                  options: _unref(getSelectOptions)('residencyResidentsDirection'),
                  placeholder: "Все направления"
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["width", "open"]))
}
}

})